import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/element'
import '@/utils/vant'
import navigtorHeader from '@/components/componentsPC/navigtor.vue'
import complianceDialog from '@/components/componentsPC/complianceDialog.vue'
import footerPage from '@/components/componentsPC/footer.vue'
import mobileFooter from '@/components/componentsMobile/footer.vue'
import mobileNavigtor from '@/components/componentsMobile/navigtor.vue'
import mobileComplianceDialog from '@/components/componentsMobile/complianceDialog.vue'
import i18n from '@/i18n/index'

Vue.config.productionTip = false
Vue.component('navigtorHeader', navigtorHeader)
Vue.component('complianceDialog', complianceDialog)
Vue.component('footerPage', footerPage)
Vue.component('mobileFooter', mobileFooter)
Vue.component('mobileNavigtor', mobileNavigtor)
Vue.component('mobileComplianceDialog', mobileComplianceDialog)

function setRem () {
  const isMobileDevice = window.matchMedia('(max-width: 767px)').matches
  let baseSize
  let scale

  // 检查窗口大小，如果小于700px，并且没有刷新过，则刷新并在localStorage设置标识
  if (window.innerWidth < 767) {
    if (!localStorage.getItem('hasReloaded')) {
      location.reload()
      localStorage.setItem('hasReloaded', 'true')
    }
  } else if (window.innerWidth >= 767) {
    if (localStorage.getItem('hasReloaded')) {
      location.reload()
      localStorage.removeItem('hasReloaded')
    }
  }
  if (!isMobileDevice) {
    baseSize = 50 // PC端基准字体大小
    scale = document.documentElement.clientWidth / 1440
    if (scale < 1) {
      scale = Math.round(scale)
    } else if (scale >= 2) {
      scale = 1
    } else {
      scale = Math.floor(scale)
    }
  } else {
    baseSize = 37.5 // 移动端
    scale = 1 // 固定为1
  }

  const size = baseSize * scale + 'px'
  document.documentElement.style.fontSize = size
}

function checkWindowWidth (list) {
  if (list.matches) {
    if (!localStorage.getItem('hasReloaded')) {
      localStorage.setItem('hasReloaded', 'true')
      location.reload()
    }
  } else if (!list.matches) {
    if (localStorage.getItem('hasReloaded')) {
      localStorage.removeItem('hasReloaded')
      location.reload()
    }
  }
  setRem()
}

const mediaQuery = window.matchMedia('(max-width: 767px)')
mediaQuery.addListener(checkWindowWidth)

// 初始执行一次
checkWindowWidth(mediaQuery)
// 初始设置一次
setRem()

// 然后监听 resize 事件，窗口尺寸改变时重新设置
window.addEventListener('resize', setRem)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
